export async function GetTimeJavamons(userId: string) {
    const url = `${process.env.REACT_APP_API_URL}:8061/jutge/usuaris/${userId}/javamons/time`;
    console.log("GetTimeJavamons URL:", url);

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if (response.status !== 200) {
            console.error("GetTimeJavamons status:", response.status);
            return [];
        }

        const data = await response.json();
        console.log("GetTimeJavamons data:", data);
        return data;
    } catch (e) {
        console.error("GetTimeJavamons error:", e);
        return [];
    }
}
